import { CircularProgress } from "@chakra-ui/react";
const LoadingSpinner = () => {
    return <CircularProgress isIndeterminate color="prussianBlue" />;
};

export default LoadingSpinner;
